// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1HUdL","content":"RecentSearches_content__3xhCU"};